var B = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Me(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function ot(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      if (this instanceof r) {
        var o = [null];
        o.push.apply(o, arguments);
        var i = Function.bind.apply(t, o);
        return new i();
      }
      return t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Be = { exports: {} };
function it(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var se = { exports: {} };
const st = {}, at = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: st
}, Symbol.toStringTag, { value: "Module" })), ct = /* @__PURE__ */ ot(at);
var Re;
function Ue() {
  return Re || (Re = 1, function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(B, function() {
      var n = n || function(r, o) {
        var i;
        if (typeof window < "u" && window.crypto && (i = window.crypto), typeof self < "u" && self.crypto && (i = self.crypto), typeof globalThis < "u" && globalThis.crypto && (i = globalThis.crypto), !i && typeof window < "u" && window.msCrypto && (i = window.msCrypto), !i && typeof B < "u" && B.crypto && (i = B.crypto), !i && typeof it == "function")
          try {
            i = ct;
          } catch {
          }
        var s = function() {
          if (i) {
            if (typeof i.getRandomValues == "function")
              try {
                return i.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof i.randomBytes == "function")
              try {
                return i.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, l = Object.create || function() {
          function u() {
          }
          return function(m) {
            var v;
            return u.prototype = m, v = new u(), u.prototype = null, v;
          };
        }(), f = {}, c = f.lib = {}, d = c.Base = function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(u) {
              var m = l(this);
              return u && m.mixIn(u), (!m.hasOwnProperty("init") || this.init === m.init) && (m.init = function() {
                m.$super.init.apply(this, arguments);
              }), m.init.prototype = m, m.$super = this, m;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var u = this.extend();
              return u.init.apply(u, arguments), u;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(u) {
              for (var m in u)
                u.hasOwnProperty(m) && (this[m] = u[m]);
              u.hasOwnProperty("toString") && (this.toString = u.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), h = c.WordArray = d.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(u, m) {
            u = this.words = u || [], m != o ? this.sigBytes = m : this.sigBytes = u.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(u) {
            return (u || w).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(u) {
            var m = this.words, v = u.words, b = this.sigBytes, R = u.sigBytes;
            if (this.clamp(), b % 4)
              for (var A = 0; A < R; A++) {
                var oe = v[A >>> 2] >>> 24 - A % 4 * 8 & 255;
                m[b + A >>> 2] |= oe << 24 - (b + A) % 4 * 8;
              }
            else
              for (var C = 0; C < R; C += 4)
                m[b + C >>> 2] = v[C >>> 2];
            return this.sigBytes += R, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var u = this.words, m = this.sigBytes;
            u[m >>> 2] &= 4294967295 << 32 - m % 4 * 8, u.length = r.ceil(m / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var u = d.clone.call(this);
            return u.words = this.words.slice(0), u;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(u) {
            for (var m = [], v = 0; v < u; v += 4)
              m.push(s());
            return new h.init(m, u);
          }
        }), y = f.enc = {}, w = y.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(u) {
            for (var m = u.words, v = u.sigBytes, b = [], R = 0; R < v; R++) {
              var A = m[R >>> 2] >>> 24 - R % 4 * 8 & 255;
              b.push((A >>> 4).toString(16)), b.push((A & 15).toString(16));
            }
            return b.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(u) {
            for (var m = u.length, v = [], b = 0; b < m; b += 2)
              v[b >>> 3] |= parseInt(u.substr(b, 2), 16) << 24 - b % 8 * 4;
            return new h.init(v, m / 2);
          }
        }, p = y.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(u) {
            for (var m = u.words, v = u.sigBytes, b = [], R = 0; R < v; R++) {
              var A = m[R >>> 2] >>> 24 - R % 4 * 8 & 255;
              b.push(String.fromCharCode(A));
            }
            return b.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(u) {
            for (var m = u.length, v = [], b = 0; b < m; b++)
              v[b >>> 2] |= (u.charCodeAt(b) & 255) << 24 - b % 4 * 8;
            return new h.init(v, m);
          }
        }, E = y.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(u) {
            try {
              return decodeURIComponent(escape(p.stringify(u)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(u) {
            return p.parse(unescape(encodeURIComponent(u)));
          }
        }, T = c.BufferedBlockAlgorithm = d.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new h.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(u) {
            typeof u == "string" && (u = E.parse(u)), this._data.concat(u), this._nDataBytes += u.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(u) {
            var m, v = this._data, b = v.words, R = v.sigBytes, A = this.blockSize, oe = A * 4, C = R / oe;
            u ? C = r.ceil(C) : C = r.max((C | 0) - this._minBufferSize, 0);
            var q = C * A, Te = r.min(q * 4, R);
            if (q) {
              for (var ie = 0; ie < q; ie += A)
                this._doProcessBlock(b, ie);
              m = b.splice(0, q), v.sigBytes -= Te;
            }
            return new h.init(m, Te);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var u = d.clone.call(this);
            return u._data = this._data.clone(), u;
          },
          _minBufferSize: 0
        });
        c.Hasher = T.extend({
          /**
           * Configuration options.
           */
          cfg: d.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(u) {
            this.cfg = this.cfg.extend(u), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            T.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(u) {
            return this._append(u), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(u) {
            u && this._append(u);
            var m = this._doFinalize();
            return m;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(u) {
            return function(m, v) {
              return new u.init(v).finalize(m);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(u) {
            return function(m, v) {
              return new S.HMAC.init(u, v).finalize(m);
            };
          }
        });
        var S = f.algo = {};
        return f;
      }(Math);
      return n;
    });
  }(se)), se.exports;
}
(function(e, t) {
  (function(n, r) {
    e.exports = r(Ue());
  })(B, function(n) {
    return function() {
      var r = n, o = r.lib, i = o.WordArray, s = r.enc;
      s.Base64 = {
        /**
         * Converts a word array to a Base64 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Base64 string.
         *
         * @static
         *
         * @example
         *
         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
         */
        stringify: function(f) {
          var c = f.words, d = f.sigBytes, h = this._map;
          f.clamp();
          for (var y = [], w = 0; w < d; w += 3)
            for (var p = c[w >>> 2] >>> 24 - w % 4 * 8 & 255, E = c[w + 1 >>> 2] >>> 24 - (w + 1) % 4 * 8 & 255, T = c[w + 2 >>> 2] >>> 24 - (w + 2) % 4 * 8 & 255, S = p << 16 | E << 8 | T, u = 0; u < 4 && w + u * 0.75 < d; u++)
              y.push(h.charAt(S >>> 6 * (3 - u) & 63));
          var m = h.charAt(64);
          if (m)
            for (; y.length % 4; )
              y.push(m);
          return y.join("");
        },
        /**
         * Converts a Base64 string to a word array.
         *
         * @param {string} base64Str The Base64 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
         */
        parse: function(f) {
          var c = f.length, d = this._map, h = this._reverseMap;
          if (!h) {
            h = this._reverseMap = [];
            for (var y = 0; y < d.length; y++)
              h[d.charCodeAt(y)] = y;
          }
          var w = d.charAt(64);
          if (w) {
            var p = f.indexOf(w);
            p !== -1 && (c = p);
          }
          return l(f, c, h);
        },
        _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
      };
      function l(f, c, d) {
        for (var h = [], y = 0, w = 0; w < c; w++)
          if (w % 4) {
            var p = d[f.charCodeAt(w - 1)] << w % 4 * 2, E = d[f.charCodeAt(w)] >>> 6 - w % 4 * 2, T = p | E;
            h[y >>> 2] |= T << 24 - y % 4 * 8, y++;
          }
        return i.create(h, y);
      }
    }(), n.enc.Base64;
  });
})(Be);
var lt = Be.exports;
const me = /* @__PURE__ */ Me(lt);
var Fe = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(Ue());
  })(B, function(n) {
    return n.enc.Utf8;
  });
})(Fe);
var ut = Fe.exports;
const we = /* @__PURE__ */ Me(ut), L = (e, t) => {
  localStorage.setItem(e, me.stringify(we.parse(t)));
}, M = (e) => {
  const t = localStorage.getItem(e);
  return t ? me.parse(t).toString(we) : null;
}, _ = (e) => {
  localStorage.removeItem(e);
}, Y = (e) => {
  const t = sessionStorage.getItem(e);
  return t ? me.parse(t).toString(we) : null;
};
function ke(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: ft } = Object.prototype, { getPrototypeOf: Ee } = Object, X = ((e) => (t) => {
  const n = ft.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), x = (e) => (e = e.toLowerCase(), (t) => X(t) === e), Q = (e) => (t) => typeof t === e, { isArray: F } = Array, j = Q("undefined");
function dt(e) {
  return e !== null && !j(e) && e.constructor !== null && !j(e.constructor) && O(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Ve = x("ArrayBuffer");
function ht(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Ve(e.buffer), t;
}
const pt = Q("string"), O = Q("function"), He = Q("number"), ee = (e) => e !== null && typeof e == "object", mt = (e) => e === !0 || e === !1, $ = (e) => {
  if (X(e) !== "object")
    return !1;
  const t = Ee(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, wt = x("Date"), Et = x("File"), yt = x("Blob"), gt = x("FileList"), vt = (e) => ee(e) && O(e.pipe), bt = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || O(e.append) && ((t = X(e)) === "formdata" || // detect form-data instance
  t === "object" && O(e.toString) && e.toString() === "[object FormData]"));
}, It = x("URLSearchParams"), Tt = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Z(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), F(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), s = i.length;
    let l;
    for (r = 0; r < s; r++)
      l = i[r], t.call(null, e[l], l, e);
  }
}
function je(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const Ze = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), ze = (e) => !j(e) && e !== Ze;
function fe() {
  const { caseless: e } = ze(this) && this || {}, t = {}, n = (r, o) => {
    const i = e && je(t, o) || o;
    $(t[i]) && $(r) ? t[i] = fe(t[i], r) : $(r) ? t[i] = fe({}, r) : F(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && Z(arguments[r], n);
  return t;
}
const Rt = (e, t, n, { allOwnKeys: r } = {}) => (Z(t, (o, i) => {
  n && O(o) ? e[i] = ke(o, n) : e[i] = o;
}, { allOwnKeys: r }), e), St = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), At = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, _t = (e, t, n, r) => {
  let o, i, s;
  const l = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      s = o[i], (!r || r(s, e, t)) && !l[s] && (t[s] = e[s], l[s] = !0);
    e = n !== !1 && Ee(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Ot = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, Ct = (e) => {
  if (!e)
    return null;
  if (F(e))
    return e;
  let t = e.length;
  if (!He(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Nt = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Ee(Uint8Array)), xt = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const i = o.value;
    t.call(e, i[0], i[1]);
  }
}, Pt = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Dt = x("HTMLFormElement"), Lt = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, o) {
    return r.toUpperCase() + o;
  }
), Se = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Mt = x("RegExp"), qe = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Z(n, (o, i) => {
    t(o, i, e) !== !1 && (r[i] = o);
  }), Object.defineProperties(e, r);
}, Bt = (e) => {
  qe(e, (t, n) => {
    if (O(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (O(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Ut = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((i) => {
      n[i] = !0;
    });
  };
  return F(e) ? r(e) : r(String(e).split(t)), n;
}, Ft = () => {
}, kt = (e, t) => (e = +e, Number.isFinite(e) ? e : t), ae = "abcdefghijklmnopqrstuvwxyz", Ae = "0123456789", $e = {
  DIGIT: Ae,
  ALPHA: ae,
  ALPHA_DIGIT: ae + ae.toUpperCase() + Ae
}, Vt = (e = 16, t = $e.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function Ht(e) {
  return !!(e && O(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const jt = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (ee(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const i = F(r) ? [] : {};
        return Z(r, (s, l) => {
          const f = n(s, o + 1);
          !j(f) && (i[l] = f);
        }), t[o] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, Zt = x("AsyncFunction"), zt = (e) => e && (ee(e) || O(e)) && O(e.then) && O(e.catch), a = {
  isArray: F,
  isArrayBuffer: Ve,
  isBuffer: dt,
  isFormData: bt,
  isArrayBufferView: ht,
  isString: pt,
  isNumber: He,
  isBoolean: mt,
  isObject: ee,
  isPlainObject: $,
  isUndefined: j,
  isDate: wt,
  isFile: Et,
  isBlob: yt,
  isRegExp: Mt,
  isFunction: O,
  isStream: vt,
  isURLSearchParams: It,
  isTypedArray: Nt,
  isFileList: gt,
  forEach: Z,
  merge: fe,
  extend: Rt,
  trim: Tt,
  stripBOM: St,
  inherits: At,
  toFlatObject: _t,
  kindOf: X,
  kindOfTest: x,
  endsWith: Ot,
  toArray: Ct,
  forEachEntry: xt,
  matchAll: Pt,
  isHTMLForm: Dt,
  hasOwnProperty: Se,
  hasOwnProp: Se,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: qe,
  freezeMethods: Bt,
  toObjectSet: Ut,
  toCamelCase: Lt,
  noop: Ft,
  toFiniteNumber: kt,
  findKey: je,
  global: Ze,
  isContextDefined: ze,
  ALPHABET: $e,
  generateString: Vt,
  isSpecCompliantForm: Ht,
  toJSONObject: jt,
  isAsyncFn: Zt,
  isThenable: zt
};
function g(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o);
}
a.inherits(g, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: a.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Je = g.prototype, We = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  We[e] = { value: e };
});
Object.defineProperties(g, We);
Object.defineProperty(Je, "isAxiosError", { value: !0 });
g.from = (e, t, n, r, o, i) => {
  const s = Object.create(Je);
  return a.toFlatObject(e, s, function(f) {
    return f !== Error.prototype;
  }, (l) => l !== "isAxiosError"), g.call(s, e.message, t, n, r, o), s.cause = e, s.name = e.name, i && Object.assign(s, i), s;
};
const qt = null;
function de(e) {
  return a.isPlainObject(e) || a.isArray(e);
}
function Ge(e) {
  return a.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function _e(e, t, n) {
  return e ? e.concat(t).map(function(o, i) {
    return o = Ge(o), !n && i ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function $t(e) {
  return a.isArray(e) && !e.some(de);
}
const Jt = a.toFlatObject(a, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function te(e, t, n) {
  if (!a.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = a.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(E, T) {
    return !a.isUndefined(T[E]);
  });
  const r = n.metaTokens, o = n.visitor || d, i = n.dots, s = n.indexes, f = (n.Blob || typeof Blob < "u" && Blob) && a.isSpecCompliantForm(t);
  if (!a.isFunction(o))
    throw new TypeError("visitor must be a function");
  function c(p) {
    if (p === null)
      return "";
    if (a.isDate(p))
      return p.toISOString();
    if (!f && a.isBlob(p))
      throw new g("Blob is not supported. Use a Buffer instead.");
    return a.isArrayBuffer(p) || a.isTypedArray(p) ? f && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function d(p, E, T) {
    let S = p;
    if (p && !T && typeof p == "object") {
      if (a.endsWith(E, "{}"))
        E = r ? E : E.slice(0, -2), p = JSON.stringify(p);
      else if (a.isArray(p) && $t(p) || (a.isFileList(p) || a.endsWith(E, "[]")) && (S = a.toArray(p)))
        return E = Ge(E), S.forEach(function(m, v) {
          !(a.isUndefined(m) || m === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? _e([E], v, i) : s === null ? E : E + "[]",
            c(m)
          );
        }), !1;
    }
    return de(p) ? !0 : (t.append(_e(T, E, i), c(p)), !1);
  }
  const h = [], y = Object.assign(Jt, {
    defaultVisitor: d,
    convertValue: c,
    isVisitable: de
  });
  function w(p, E) {
    if (!a.isUndefined(p)) {
      if (h.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + E.join("."));
      h.push(p), a.forEach(p, function(S, u) {
        (!(a.isUndefined(S) || S === null) && o.call(
          t,
          S,
          a.isString(u) ? u.trim() : u,
          E,
          y
        )) === !0 && w(S, E ? E.concat(u) : [u]);
      }), h.pop();
    }
  }
  if (!a.isObject(e))
    throw new TypeError("data must be an object");
  return w(e), t;
}
function Oe(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function ye(e, t) {
  this._pairs = [], e && te(e, this, t);
}
const Ye = ye.prototype;
Ye.append = function(t, n) {
  this._pairs.push([t, n]);
};
Ye.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Oe);
  } : Oe;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function Wt(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Ke(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || Wt, o = n && n.serialize;
  let i;
  if (o ? i = o(t, n) : i = a.isURLSearchParams(t) ? t.toString() : new ye(t, n).toString(r), i) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Gt {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    a.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const Ce = Gt, Xe = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Yt = typeof URLSearchParams < "u" ? URLSearchParams : ye, Kt = typeof FormData < "u" ? FormData : null, Xt = typeof Blob < "u" ? Blob : null, Qt = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), en = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), N = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Yt,
    FormData: Kt,
    Blob: Xt
  },
  isStandardBrowserEnv: Qt,
  isStandardBrowserWebWorkerEnv: en,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function tn(e, t) {
  return te(e, new N.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, i) {
      return N.isNode && a.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function nn(e) {
  return a.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function rn(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let i;
  for (r = 0; r < o; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function Qe(e) {
  function t(n, r, o, i) {
    let s = n[i++];
    const l = Number.isFinite(+s), f = i >= n.length;
    return s = !s && a.isArray(o) ? o.length : s, f ? (a.hasOwnProp(o, s) ? o[s] = [o[s], r] : o[s] = r, !l) : ((!o[s] || !a.isObject(o[s])) && (o[s] = []), t(n, r, o[s], i) && a.isArray(o[s]) && (o[s] = rn(o[s])), !l);
  }
  if (a.isFormData(e) && a.isFunction(e.entries)) {
    const n = {};
    return a.forEachEntry(e, (r, o) => {
      t(nn(r), o, n, 0);
    }), n;
  }
  return null;
}
const on = {
  "Content-Type": void 0
};
function sn(e, t, n) {
  if (a.isString(e))
    try {
      return (t || JSON.parse)(e), a.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const ne = {
  transitional: Xe,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", o = r.indexOf("application/json") > -1, i = a.isObject(t);
    if (i && a.isHTMLForm(t) && (t = new FormData(t)), a.isFormData(t))
      return o && o ? JSON.stringify(Qe(t)) : t;
    if (a.isArrayBuffer(t) || a.isBuffer(t) || a.isStream(t) || a.isFile(t) || a.isBlob(t))
      return t;
    if (a.isArrayBufferView(t))
      return t.buffer;
    if (a.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let l;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return tn(t, this.formSerializer).toString();
      if ((l = a.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const f = this.env && this.env.FormData;
        return te(
          l ? { "files[]": t } : t,
          f && new f(),
          this.formSerializer
        );
      }
    }
    return i || o ? (n.setContentType("application/json", !1), sn(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || ne.transitional, r = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (t && a.isString(t) && (r && !this.responseType || o)) {
      const s = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (l) {
        if (s)
          throw l.name === "SyntaxError" ? g.from(l, g.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: N.classes.FormData,
    Blob: N.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
a.forEach(["delete", "get", "head"], function(t) {
  ne.headers[t] = {};
});
a.forEach(["post", "put", "patch"], function(t) {
  ne.headers[t] = a.merge(on);
});
const ge = ne, an = a.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), cn = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(s) {
    o = s.indexOf(":"), n = s.substring(0, o).trim().toLowerCase(), r = s.substring(o + 1).trim(), !(!n || t[n] && an[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, Ne = Symbol("internals");
function V(e) {
  return e && String(e).trim().toLowerCase();
}
function J(e) {
  return e === !1 || e == null ? e : a.isArray(e) ? e.map(J) : String(e);
}
function ln(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const un = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ce(e, t, n, r, o) {
  if (a.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!a.isString(t)) {
    if (a.isString(r))
      return t.indexOf(r) !== -1;
    if (a.isRegExp(r))
      return r.test(t);
  }
}
function fn(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function dn(e, t) {
  const n = a.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, i, s) {
        return this[r].call(this, t, o, i, s);
      },
      configurable: !0
    });
  });
}
class re {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const o = this;
    function i(l, f, c) {
      const d = V(f);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const h = a.findKey(o, d);
      (!h || o[h] === void 0 || c === !0 || c === void 0 && o[h] !== !1) && (o[h || f] = J(l));
    }
    const s = (l, f) => a.forEach(l, (c, d) => i(c, d, f));
    return a.isPlainObject(t) || t instanceof this.constructor ? s(t, n) : a.isString(t) && (t = t.trim()) && !un(t) ? s(cn(t), n) : t != null && i(n, t, r), this;
  }
  get(t, n) {
    if (t = V(t), t) {
      const r = a.findKey(this, t);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return ln(o);
        if (a.isFunction(n))
          return n.call(this, o, r);
        if (a.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = V(t), t) {
      const r = a.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || ce(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let o = !1;
    function i(s) {
      if (s = V(s), s) {
        const l = a.findKey(r, s);
        l && (!n || ce(r, r[l], l, n)) && (delete r[l], o = !0);
      }
    }
    return a.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || ce(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, r = {};
    return a.forEach(this, (o, i) => {
      const s = a.findKey(r, i);
      if (s) {
        n[s] = J(o), delete n[i];
        return;
      }
      const l = t ? fn(i) : String(i).trim();
      l !== i && delete n[i], n[l] = J(o), r[l] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return a.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = t && a.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(t) {
    const r = (this[Ne] = this[Ne] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function i(s) {
      const l = V(s);
      r[l] || (dn(o, s), r[l] = !0);
    }
    return a.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
re.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
a.freezeMethods(re.prototype);
a.freezeMethods(re);
const P = re;
function le(e, t) {
  const n = this || ge, r = t || n, o = P.from(r.headers);
  let i = r.data;
  return a.forEach(e, function(l) {
    i = l.call(n, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function et(e) {
  return !!(e && e.__CANCEL__);
}
function z(e, t, n) {
  g.call(this, e ?? "canceled", g.ERR_CANCELED, t, n), this.name = "CanceledError";
}
a.inherits(z, g, {
  __CANCEL__: !0
});
function hn(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new g(
    "Request failed with status code " + n.status,
    [g.ERR_BAD_REQUEST, g.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const pn = N.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(n, r, o, i, s, l) {
        const f = [];
        f.push(n + "=" + encodeURIComponent(r)), a.isNumber(o) && f.push("expires=" + new Date(o).toGMTString()), a.isString(i) && f.push("path=" + i), a.isString(s) && f.push("domain=" + s), l === !0 && f.push("secure"), document.cookie = f.join("; ");
      },
      read: function(n) {
        const r = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
        return r ? decodeURIComponent(r[3]) : null;
      },
      remove: function(n) {
        this.write(n, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function mn(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function wn(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function tt(e, t) {
  return e && !mn(t) ? wn(e, t) : t;
}
const En = N.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function o(i) {
      let s = i;
      return t && (n.setAttribute("href", s), s = n.href), n.setAttribute("href", s), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = o(window.location.href), function(s) {
      const l = a.isString(s) ? o(s) : s;
      return l.protocol === r.protocol && l.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function yn(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function gn(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, i = 0, s;
  return t = t !== void 0 ? t : 1e3, function(f) {
    const c = Date.now(), d = r[i];
    s || (s = c), n[o] = f, r[o] = c;
    let h = i, y = 0;
    for (; h !== o; )
      y += n[h++], h = h % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), c - s < t)
      return;
    const w = d && c - d;
    return w ? Math.round(y * 1e3 / w) : void 0;
  };
}
function xe(e, t) {
  let n = 0;
  const r = gn(50, 250);
  return (o) => {
    const i = o.loaded, s = o.lengthComputable ? o.total : void 0, l = i - n, f = r(l), c = i <= s;
    n = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: f || void 0,
      estimated: f && s && c ? (s - i) / f : void 0,
      event: o
    };
    d[t ? "download" : "upload"] = !0, e(d);
  };
}
const vn = typeof XMLHttpRequest < "u", bn = vn && function(e) {
  return new Promise(function(n, r) {
    let o = e.data;
    const i = P.from(e.headers).normalize(), s = e.responseType;
    let l;
    function f() {
      e.cancelToken && e.cancelToken.unsubscribe(l), e.signal && e.signal.removeEventListener("abort", l);
    }
    a.isFormData(o) && (N.isStandardBrowserEnv || N.isStandardBrowserWebWorkerEnv ? i.setContentType(!1) : i.setContentType("multipart/form-data;", !1));
    let c = new XMLHttpRequest();
    if (e.auth) {
      const w = e.auth.username || "", p = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      i.set("Authorization", "Basic " + btoa(w + ":" + p));
    }
    const d = tt(e.baseURL, e.url);
    c.open(e.method.toUpperCase(), Ke(d, e.params, e.paramsSerializer), !0), c.timeout = e.timeout;
    function h() {
      if (!c)
        return;
      const w = P.from(
        "getAllResponseHeaders" in c && c.getAllResponseHeaders()
      ), E = {
        data: !s || s === "text" || s === "json" ? c.responseText : c.response,
        status: c.status,
        statusText: c.statusText,
        headers: w,
        config: e,
        request: c
      };
      hn(function(S) {
        n(S), f();
      }, function(S) {
        r(S), f();
      }, E), c = null;
    }
    if ("onloadend" in c ? c.onloadend = h : c.onreadystatechange = function() {
      !c || c.readyState !== 4 || c.status === 0 && !(c.responseURL && c.responseURL.indexOf("file:") === 0) || setTimeout(h);
    }, c.onabort = function() {
      c && (r(new g("Request aborted", g.ECONNABORTED, e, c)), c = null);
    }, c.onerror = function() {
      r(new g("Network Error", g.ERR_NETWORK, e, c)), c = null;
    }, c.ontimeout = function() {
      let p = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const E = e.transitional || Xe;
      e.timeoutErrorMessage && (p = e.timeoutErrorMessage), r(new g(
        p,
        E.clarifyTimeoutError ? g.ETIMEDOUT : g.ECONNABORTED,
        e,
        c
      )), c = null;
    }, N.isStandardBrowserEnv) {
      const w = (e.withCredentials || En(d)) && e.xsrfCookieName && pn.read(e.xsrfCookieName);
      w && i.set(e.xsrfHeaderName, w);
    }
    o === void 0 && i.setContentType(null), "setRequestHeader" in c && a.forEach(i.toJSON(), function(p, E) {
      c.setRequestHeader(E, p);
    }), a.isUndefined(e.withCredentials) || (c.withCredentials = !!e.withCredentials), s && s !== "json" && (c.responseType = e.responseType), typeof e.onDownloadProgress == "function" && c.addEventListener("progress", xe(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && c.upload && c.upload.addEventListener("progress", xe(e.onUploadProgress)), (e.cancelToken || e.signal) && (l = (w) => {
      c && (r(!w || w.type ? new z(null, e, c) : w), c.abort(), c = null);
    }, e.cancelToken && e.cancelToken.subscribe(l), e.signal && (e.signal.aborted ? l() : e.signal.addEventListener("abort", l)));
    const y = yn(d);
    if (y && N.protocols.indexOf(y) === -1) {
      r(new g("Unsupported protocol " + y + ":", g.ERR_BAD_REQUEST, e));
      return;
    }
    c.send(o || null);
  });
}, W = {
  http: qt,
  xhr: bn
};
a.forEach(W, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const In = {
  getAdapter: (e) => {
    e = a.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    for (let o = 0; o < t && (n = e[o], !(r = a.isString(n) ? W[n.toLowerCase()] : n)); o++)
      ;
    if (!r)
      throw r === !1 ? new g(
        `Adapter ${n} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        a.hasOwnProp(W, n) ? `Adapter '${n}' is not available in the build` : `Unknown adapter '${n}'`
      );
    if (!a.isFunction(r))
      throw new TypeError("adapter is not a function");
    return r;
  },
  adapters: W
};
function ue(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new z(null, e);
}
function Pe(e) {
  return ue(e), e.headers = P.from(e.headers), e.data = le.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), In.getAdapter(e.adapter || ge.adapter)(e).then(function(r) {
    return ue(e), r.data = le.call(
      e,
      e.transformResponse,
      r
    ), r.headers = P.from(r.headers), r;
  }, function(r) {
    return et(r) || (ue(e), r && r.response && (r.response.data = le.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = P.from(r.response.headers))), Promise.reject(r);
  });
}
const De = (e) => e instanceof P ? e.toJSON() : e;
function U(e, t) {
  t = t || {};
  const n = {};
  function r(c, d, h) {
    return a.isPlainObject(c) && a.isPlainObject(d) ? a.merge.call({ caseless: h }, c, d) : a.isPlainObject(d) ? a.merge({}, d) : a.isArray(d) ? d.slice() : d;
  }
  function o(c, d, h) {
    if (a.isUndefined(d)) {
      if (!a.isUndefined(c))
        return r(void 0, c, h);
    } else
      return r(c, d, h);
  }
  function i(c, d) {
    if (!a.isUndefined(d))
      return r(void 0, d);
  }
  function s(c, d) {
    if (a.isUndefined(d)) {
      if (!a.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, d);
  }
  function l(c, d, h) {
    if (h in t)
      return r(c, d);
    if (h in e)
      return r(void 0, c);
  }
  const f = {
    url: i,
    method: i,
    data: i,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (c, d) => o(De(c), De(d), !0)
  };
  return a.forEach(Object.keys(Object.assign({}, e, t)), function(d) {
    const h = f[d] || o, y = h(e[d], t[d], d);
    a.isUndefined(y) && h !== l || (n[d] = y);
  }), n;
}
const nt = "1.4.0", ve = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  ve[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Le = {};
ve.transitional = function(t, n, r) {
  function o(i, s) {
    return "[Axios v" + nt + "] Transitional option '" + i + "'" + s + (r ? ". " + r : "");
  }
  return (i, s, l) => {
    if (t === !1)
      throw new g(
        o(s, " has been removed" + (n ? " in " + n : "")),
        g.ERR_DEPRECATED
      );
    return n && !Le[s] && (Le[s] = !0, console.warn(
      o(
        s,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, s, l) : !0;
  };
};
function Tn(e, t, n) {
  if (typeof e != "object")
    throw new g("options must be an object", g.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const i = r[o], s = t[i];
    if (s) {
      const l = e[i], f = l === void 0 || s(l, i, e);
      if (f !== !0)
        throw new g("option " + i + " must be " + f, g.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new g("Unknown option " + i, g.ERR_BAD_OPTION);
  }
}
const he = {
  assertOptions: Tn,
  validators: ve
}, D = he.validators;
class K {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Ce(),
      response: new Ce()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = U(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: i } = n;
    r !== void 0 && he.assertOptions(r, {
      silentJSONParsing: D.transitional(D.boolean),
      forcedJSONParsing: D.transitional(D.boolean),
      clarifyTimeoutError: D.transitional(D.boolean)
    }, !1), o != null && (a.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : he.assertOptions(o, {
      encode: D.function,
      serialize: D.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let s;
    s = i && a.merge(
      i.common,
      i[n.method]
    ), s && a.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete i[p];
      }
    ), n.headers = P.concat(s, i);
    const l = [];
    let f = !0;
    this.interceptors.request.forEach(function(E) {
      typeof E.runWhen == "function" && E.runWhen(n) === !1 || (f = f && E.synchronous, l.unshift(E.fulfilled, E.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(E) {
      c.push(E.fulfilled, E.rejected);
    });
    let d, h = 0, y;
    if (!f) {
      const p = [Pe.bind(this), void 0];
      for (p.unshift.apply(p, l), p.push.apply(p, c), y = p.length, d = Promise.resolve(n); h < y; )
        d = d.then(p[h++], p[h++]);
      return d;
    }
    y = l.length;
    let w = n;
    for (h = 0; h < y; ) {
      const p = l[h++], E = l[h++];
      try {
        w = p(w);
      } catch (T) {
        E.call(this, T);
        break;
      }
    }
    try {
      d = Pe.call(this, w);
    } catch (p) {
      return Promise.reject(p);
    }
    for (h = 0, y = c.length; h < y; )
      d = d.then(c[h++], c[h++]);
    return d;
  }
  getUri(t) {
    t = U(this.defaults, t);
    const n = tt(t.baseURL, t.url);
    return Ke(n, t.params, t.paramsSerializer);
  }
}
a.forEach(["delete", "get", "head", "options"], function(t) {
  K.prototype[t] = function(n, r) {
    return this.request(U(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
a.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, s, l) {
      return this.request(U(l || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: s
      }));
    };
  }
  K.prototype[t] = n(), K.prototype[t + "Form"] = n(!0);
});
const G = K;
class be {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const s = new Promise((l) => {
        r.subscribe(l), i = l;
      }).then(o);
      return s.cancel = function() {
        r.unsubscribe(i);
      }, s;
    }, t(function(i, s, l) {
      r.reason || (r.reason = new z(i, s, l), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new be(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
const Rn = be;
function Sn(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function An(e) {
  return a.isObject(e) && e.isAxiosError === !0;
}
const pe = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(pe).forEach(([e, t]) => {
  pe[t] = e;
});
const _n = pe;
function rt(e) {
  const t = new G(e), n = ke(G.prototype.request, t);
  return a.extend(n, G.prototype, t, { allOwnKeys: !0 }), a.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return rt(U(e, o));
  }, n;
}
const I = rt(ge);
I.Axios = G;
I.CanceledError = z;
I.CancelToken = Rn;
I.isCancel = et;
I.VERSION = nt;
I.toFormData = te;
I.AxiosError = g;
I.Cancel = I.CanceledError;
I.all = function(t) {
  return Promise.all(t);
};
I.spread = Sn;
I.isAxiosError = An;
I.mergeConfig = U;
I.AxiosHeaders = P;
I.formToJSON = (e) => Qe(a.isHTMLForm(e) ? new FormData(e) : e);
I.HttpStatusCode = _n;
I.default = I;
const On = I, k = async function(e) {
  const t = {
    INTERMEDIARY: window.VITE_API_INTERMEDIARY_SEGURITY ? window.VITE_API_INTERMEDIARY_SEGURITY : "https://ms-agetic.mp.gob.bo",
    LOCAL_FIRMATIC: window.VITE_API_LOCAL_FIRMATIC ? window.VITE_API_LOCAL_FIRMATIC : "https://localhost:4637"
    //GET_IP_ONLINE:({}).VITE_API_GET_IP_ONLINE
  }, n = {
    TOKEN_SEGURITY: window.VITE_TOKEN_SEGURITY_AGETIC ? window.VITE_TOKEN_SEGURITY_AGETIC : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VieSI6IkluaWNpbyBkZSBGbHVqbyIsInVzZXIiOnsiY2kiOiIxMDUyMDA2NyJ9LCJpbml0RmxvdyI6dHJ1ZSwiaWF0IjoxNjk0NjY2MDExLCJleHAiOjI1NTg2NjYwMTF9.QVo3kF9jHIKCmCfczq7hfA1je0taNinidwEHBAOCYlw",
    TOKEN_INTERMEDIARY: M("ms_itm")
  }, r = e, o = t[e.apiServer], i = {
    method: r.method,
    url: `${o}${r.url}`,
    headers: {
      // 'Authorization': `Bearer ${getOptions.token?getOptions.token:''}`,
      Authorization: `Bearer ${n[e.tokenUseApi]}`,
      "Content-Type": "application/json; charset=utf-8",
      ...r.headers
    },
    data: r.data
  };
  return await On(i).then(async function(s) {
    var f;
    let l;
    return e.apiServer === "LOCAL_FIRMATIC" ? l = await s.data : l = await ((f = s.data) == null ? void 0 : f.response), l;
  }).catch(async function(s) {
    var f;
    const l = (f = s.response) == null ? void 0 : f.data;
    if (console.error(l), s.code === "ERR_NETWORK" || s.code === "ERR_BAD_REQUEST")
      throw l;
  });
}, Cn = async (e, t = null, n = !0) => {
  const r = {
    apiServer: "INTERMEDIARY",
    url: "/api/v1/ciudadania/digital/autenticacion/generar-url-agetic",
    method: "POST",
    tokenUseApi: "TOKEN_SEGURITY",
    data: {
      urlRedirectLogin: window.VITE_API_BASE_URL ? window.VITE_API_BASE_URL : "http://127.0.0.1:5173",
      application: window.VITE_API_APLICATION ? window.VITE_API_APLICATION : "jl2",
      verifyFunctionary: n,
      developmentEnvironment: window.VITE_DEVELOPMENT_ENVIRONMENT ? window.VITE_DEVELOPMENT_ENVIRONMENT : "PRODUCTION",
      solicitudNavigationID: Y("tabIdAgetic"),
      beforeAgetic: e,
      tokenMsSeguridad: t
    }
  };
  return await k(r).then((o) => (L("dataAgetic", o), o)).catch((o) => {
    throw o;
  });
}, Nn = async (e) => await k({
  apiServer: "INTERMEDIARY",
  url: "/api/v1/ciudadania/digital/session-auth",
  method: "POST",
  tokenUseApi: "TOKEN_SEGURITY",
  data: {
    binnacleId: e
  }
}).then((n) => (L("ms_itm", n.tokenUseApi), n)).catch((n) => {
  throw n;
}), xn = async () => await k({
  apiServer: "LOCAL_FIRMATIC",
  url: "/",
  method: "GET",
  data: {}
}).then((t) => t).catch((t) => {
  throw t;
}), Pn = async (e) => {
  const t = {
    apiServer: "INTERMEDIARY",
    url: "/api/v1/notificationes/iniciar",
    method: "POST",
    //token,
    tokenUseApi: "TOKEN_SEGURITY",
    data: {
      ...e,
      solicitudNavigationID: Y("tabIdAgetic"),
      developmentEnvironment: window.VITE_DEVELOPMENT_ENVIRONMENT ? window.VITE_DEVELOPMENT_ENVIRONMENT : "PRODUCTION"
    }
  };
  return await k(t).then((n) => n).catch((n) => {
    throw document.dispatchEvent(new CustomEvent("timeLineErrorNotification")), n;
  });
}, Dn = async (e) => await k({
  apiServer: "LOCAL_FIRMATIC",
  url: "/sign-hash",
  method: "POST",
  data: e
}).then((n) => n).catch((n) => {
  throw document.dispatchEvent(new CustomEvent("timeLineErrorNotification")), n;
}), Ln = async (e) => await k({
  apiServer: "INTERMEDIARY",
  url: "/api/v1/notificationes/finalizar",
  method: "POST",
  //token,
  tokenUseApi: "TOKEN_SEGURITY",
  data: e
}).then((n) => (document.dispatchEvent(new CustomEvent("timeLineSuccessNotification")), n.response)).catch((n) => {
  throw document.dispatchEvent(new CustomEvent("timeLineErrorNotification")), n;
}), Ie = function() {
  let e = !1;
  return function(t) {
    (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))) && (e = !0);
  }(navigator.userAgent || navigator.vendor || window.opera), e;
};
function H() {
  const e = document.createElement("div");
  if (e)
    return e.innerHTML = `
        <style>
            .icon_1 {
            height: 132px;
        }

        .icon_1 {
            animation: rotate 1.25s linear infinite;
        }

        @keyframes rotate {
            100% {
                transform: rotate(-360deg);
            }
        }
        .icon_2 {
            width: 80px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        .relative {
            position: relative !important;
        }
        </style>

        <div class="relative">
            <!-- SPINNER ICON -->
            <svg class="icon_1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 275 276">
            <path
                fill="url(#a)"
                d="M137.1 1c-12.9 0-25.9 1.8-38.8 5.6A136.91 136.91 0 0 0 5.7 176.7 14.4 14.4 0 0 0 19.5 187c6.2 0 2.7-.2 4.1-.6 7.6-2.3 12-10.3 9.7-17.9-3-10.2-4.5-20.5-4.5-30.7 0-23.3 7.6-45.8 21.1-64.1a106.7 106.7 0 0 1 56.4-39.5c10.2-3 20.5-4.5 30.7-4.5 23.3 0 45.8 7.6 64.1 21.1a106.7 106.7 0 0 1 39.5 56.4 14.4 14.4 0 0 0 13.8 10.3c6.2 0 2.7-.2 4.1-.6 7.6-2.3 12-10.3 9.7-17.9A136.91 136.91 0 0 0 136.9.8"
            />
            <path
                fill="url(#b)"
                d="M254.5 88.9a14.41 14.41 0 0 0-13.8 18.5c3 10.2 4.5 20.5 4.5 30.7 0 23.3-7.6 45.8-21.1 64.1a106.7 106.7 0 0 1-56.4 39.5c-10.2 3-20.5 4.5-30.7 4.5-23.3 0-45.8-7.6-64.1-21.1a106.7 106.7 0 0 1-39.5-56.4 14.4 14.4 0 0 0-13.8-10.3c-6.2 0-2.7.2-4.1.6-7.6 2.3-12 10.3-9.7 17.9a136.91 136.91 0 0 0 170.1 92.6 136.91 136.91 0 0 0 92.6-170.1 14.4 14.4 0 0 0-13.8-10.3"
            />
            <defs>
                <linearGradient id="a" x1="0" x2="269" y1="94.1" y2="94.1" gradientUnits="userSpaceOnUse">
                <stop stop-color="#fff" />
                <stop offset="1" stop-color="#fff" stop-opacity="0" />
                </linearGradient>
                <linearGradient id="b" x1="5" x2="274" y1="181.9" y2="181.9" gradientUnits="userSpaceOnUse">
                <stop stop-color="#fff" stop-opacity="0" />
                <stop offset="1" stop-color="#fff" />
                </linearGradient>
            </defs>
            </svg>
            <!-- TEXTO SVG -->
            <svg class="icon_2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 176 74">
            <path
                fill="#fff"
                d="M6.4 70v-3.5c-.3 1.3-1.5 4.5-2.2 6.6h-.8c-.6-1.7-1.7-5.2-2.1-6.6v6.6H.5v-7.3h1.4c.8 2.1 1.7 5.1 2 6.1.1-.7 1.3-3.9 2.1-6.1h1.3v7.3h-.9V70ZM10.8 65.8v7.3h-.9v-7.3h.9ZM13.5 73.1v-7.3h1.2c2.9 5.1 3.3 5.8 3.4 6.2v-6.1h.9v7.3h-1.1c-3.1-5.6-3.3-6-3.5-6.3v6.4h-.8l-.1-.2ZM22.5 65.8v7.3h-.9v-7.3h.9ZM25.5 71c.1.9.8 1.4 1.6 1.4s1.4-.4 1.4-1.3-.4-1.1-1.7-1.5c-1.5-.5-2.1-1-2.1-2s.9-1.9 2.2-1.9c1.3 0 2.2.9 2.3 1.9h-.9c-.1-.7-.5-1.2-1.4-1.2-.9 0-1.3.4-1.3 1.1 0 .7.4.9 1.5 1.3 1.8.5 2.2 1.2 2.2 2.2 0 1-.8 2.1-2.4 2.1-1.6 0-2.4-.8-2.5-2.1h1.1ZM32.9 66.6h-2.1v-.8H36v.8h-2.1v6.5H33v-6.5h-.1ZM41.9 69.6h-3.3v2.6h3.6v.8h-4.5v-7.3H42v.8h-3.4v2.3h3.3v.8ZM45.2 69.8v3.3h-.9v-7.3h2.6c1.3 0 2.2.6 2.2 1.9 0 1.3-.6 1.5-1.2 1.7.8.2 1.1.8 1.1 1.8 0 .8 0 1.4.1 1.9h-.9c0-.3-.1-1-.1-1.7 0-1.2-.4-1.6-1.6-1.6h-1.3Zm0-.7h1.3c.9 0 1.6-.3 1.6-1.3s-.5-1.2-1.4-1.2h-1.6v2.5h.1ZM52.3 65.8v7.3h-.9v-7.3h.9ZM60.7 69.4c0 2.1-1 3.8-3.1 3.8s-3-1.6-3-3.8c0-2.2 1-3.7 3.1-3.7s3 1.6 3 3.7Zm-5.2 0c0 1.7.7 3 2.1 3 1.4 0 2.1-1.3 2.1-3s-.7-2.9-2.1-2.9c-1.4 0-2.1 1.3-2.1 2.9ZM66.5 65.8h2.4c1.3 0 2.3.7 2.3 2s-1 2.1-2.5 2.1h-1.4V73h-.9v-7.3l.1.1Zm.9 3.4h1.4c.9 0 1.6-.3 1.6-1.4 0-1.1-.6-1.3-1.6-1.3h-1.4v2.7ZM74.2 65.8v4.6c0 1.1.4 2 1.7 2 1.3 0 1.7-.8 1.7-2v-4.6h.9v4.6c0 1.5-.6 2.7-2.6 2.7s-2.6-1-2.6-2.7v-4.7h.9v.1Zm3.5-2.1-1.6 1.4h-.9l1.3-1.4H77.7ZM81.1 65.8h2.5c1.3 0 2.1.7 2.1 1.8s-.6 1.4-1 1.5c.5.2 1.3.6 1.3 1.8 0 1.2-1 2.1-2.4 2.1h-2.4v-7.3l-.1.1Zm2.3 3c1 0 1.4-.4 1.4-1.1 0-.7-.4-1.1-1.4-1.1h-1.5v2.3h1.4l.1-.1ZM82 72.3h1.5c.9 0 1.6-.4 1.6-1.4 0-1-.6-1.4-1.7-1.4H82v2.8ZM88.2 65.8h.9v6.5h3.5v.8h-4.4v-7.3ZM95.3 65.8v7.3h-.9v-7.3h.9ZM103.2 71c-.2 1.2-1 2.2-2.7 2.2-1.7 0-2.9-1.6-2.9-3.8 0-2.2.9-3.7 3-3.7s2.4 1 2.6 2.2h-.9c-.2-.8-.6-1.5-1.7-1.5s-2 1.4-2 2.9.5 3 2 3 1.5-.6 1.7-1.5h.9v.2ZM111.1 69.4c0 2.1-1 3.8-3.1 3.8s-3-1.6-3-3.8c0-2.2 1-3.7 3.1-3.7s3 1.6 3 3.7Zm-5.2 0c0 1.7.7 3 2.1 3 1.4 0 2.1-1.3 2.1-3s-.7-2.9-2.1-2.9c-1.4 0-2.1 1.3-2.1 2.9ZM116.9 65.8h2.4c1.8 0 3.2 1.2 3.2 3.5s-1.2 3.8-3.4 3.8h-2.2v-7.3Zm.9 6.5h1.3c1.7 0 2.5-1.1 2.5-3s-1-2.7-2.4-2.7h-1.3v5.8l-.1-.1ZM128.9 69.6h-3.3v2.6h3.6v.8h-4.5v-7.3h4.3v.8h-3.4v2.3h3.3v.8ZM134.8 65.8h2.5c1.3 0 2.1.7 2.1 1.8s-.6 1.4-1 1.5c.5.2 1.3.6 1.3 1.8 0 1.2-1 2.1-2.4 2.1h-2.4v-7.3l-.1.1Zm2.3 3c1 0 1.4-.4 1.4-1.1 0-.7-.4-1.1-1.4-1.1h-1.5v2.3h1.4l.1-.1Zm-1.4 3.5h1.5c.9 0 1.6-.4 1.6-1.4 0-1-.6-1.4-1.7-1.4h-1.4v2.8ZM147.7 69.4c0 2.1-1 3.8-3.1 3.8s-3-1.6-3-3.8c0-2.2 1-3.7 3.1-3.7s3 1.6 3 3.7Zm-5.2 0c0 1.7.7 3 2.1 3 1.4 0 2.1-1.3 2.1-3s-.7-2.9-2.1-2.9c-1.4 0-2.1 1.3-2.1 2.9ZM150 65.8h.9v6.5h3.5v.8H150v-7.3ZM157.1 65.8v7.3h-.9v-7.3h.9ZM161.3 73.1l-2.4-7.3h1l1.1 3.6c.3 1 .7 2.1.8 2.8.1-.6.6-1.8.9-2.8l1.2-3.6h.9l-2.5 7.3h-1.1.1ZM167.6 65.8v7.3h-.9v-7.3h.9ZM171.1 70.9l-.7 2.2h-.9l2.4-7.3h1.1l2.5 7.3h-1l-.7-2.2h-2.7Zm2.4-.8c-.6-1.9-1-2.9-1.1-3.5-.2.9-.6 2-1.1 3.5h2.2ZM8.2 49.2c0 3.8-.9 6.3-5.5 6.3s-1.7 0-2.2-.2v-3.4c.4 0 .9.1 1.5.1 1.8 0 2.1-.9 2.1-2.6V32.3h4.1v16.9ZM15.3 32.4v15.7c0 1.9.5 4.1 3 4.1s3-1.9 3-4.1V32.3h4.1v15.8c0 4.1-1.6 7.4-7.1 7.4s-7-3.1-7-7.4V32.3h4.1l-.1.1ZM31.5 48.8c.2 1.9 1 3.6 3.1 3.6s2.8-1.3 2.8-3-.9-3-3.8-4.4c-3.9-1.9-5.5-3.5-5.5-6.9 0-3.4 2.4-6.2 6.5-6.2s6.4 3.5 6.5 6.5h-4c-.1-1.3-.5-3.2-2.5-3.2s-2.3 1.1-2.3 2.6.7 2.4 3.4 3.7c4.1 1.9 5.9 3.7 5.9 7.6 0 3.9-2.2 6.6-7.1 6.6-4.9 0-6.9-3.4-7-6.8h4.1l-.1-.1ZM47 35.9h-4.9v-3.6H56v3.6h-4.9v19.3H47V35.9ZM61.8 32.4v22.9h-4.1V32.4h4.1ZM78.7 48.6c-.1 1.2-.5 7.1-6.9 7.1s-7.3-5.7-7.3-11.9S66.7 32 72 32s6.5 5.2 6.6 7h-4.1c0-.8-.1-3.6-2.6-3.6s-3.2 3.1-3.2 8.4c0 5.3.4 8.4 3.1 8.4s2.6-2.8 2.7-3.6H78.7ZM84.8 32.4v22.9h-4.1V32.4h4.1ZM91.8 49.5l-1.1 5.8h-4.1l5.3-22.9h5.3l5.4 22.9h-4.3l-1.1-5.8H91.8Zm4.6-3.6c-.9-4.4-1.5-7.6-1.9-9.8-.3 2.1-1 5.5-1.8 9.8h3.8-.1ZM109.9 32.4h4.1v19.4h7.8l-.4 3.5h-11.5V32.4ZM127.5 32.4v22.9h-4.1V32.4h4.1ZM131 32.4h7c4 0 6.2 2.2 6.2 5.8 0 3.6-1.4 4.3-2.6 4.8 1.6.7 3.3 2.1 3.3 5.6 0 3.5-2.8 6.7-6.9 6.7h-6.9V32.4h-.1Zm6 9.1c2.5 0 3.2-1 3.2-3s-1.1-2.9-3.1-2.9H135v5.9h2Zm-2 10.6h2.4c2 0 3.2-1 3.2-3.6s-1-3.7-3.7-3.7h-2v7.4l.1-.1ZM151.2 45.5v9.8h-4.1V32.4h7c4.2 0 6.5 2.2 6.5 6.3s-1.8 4.7-3 5.2c1.8.8 2.6 2.3 2.6 5.7v.9c0 2.6.1 3.6.3 4.8h-4c-.3-1-.4-2.9-.4-4.8v-.8c0-3.1-.7-4.1-3.3-4.1H151l.2-.1Zm0-3.3h1.9c2.5 0 3.4-1.1 3.4-3.4s-.9-3.1-3-3.1h-2.3v6.5ZM174.6 45.1h-7.3v6.6h8.2l-.5 3.5h-11.8V32.3h11.7v3.6h-7.7v5.6h7.3v3.6h.1ZM10 12.3H2.9v8.2h7.9l-.3 2.1H.6V1.2h9.8v2.1H2.9v7H10v2.1-.1ZM29.4 16.6c0 1.2-.6 6.2-5.8 6.2s-6.1-6-6.1-11.2C17.5 6.4 19.1.7 23.9.7c4.8 0 5.4 4.8 5.5 6.1H27c0-.7-.2-4-3.2-4s-3.9 4.6-3.9 8.8c0 4.2.5 9.1 3.7 9.1s3.3-3.1 3.4-4.2h2.4v.1ZM49.2 11.7c0 7.3-1.7 11.2-6.4 11.2s-6.2-3.8-6.2-11.2C36.6 4.3 38.7.8 42.9.8c4.2 0 6.3 3.6 6.3 10.8v.1Zm-10.2 0c0 6.1 1.2 9.2 3.9 9.2s3.9-3 3.9-9.1S45.6 3 42.9 3 39 5.9 39 11.8v-.1ZM58.4 16.9c.2 2.2 1.2 4 3.6 4 2.4 0 3.4-1.2 3.4-3.7s-.9-3.5-3.8-4.9c-3.4-1.6-4.8-3.1-4.8-6.2S58.7.8 62.2.8c3.5 0 5.3 3 5.3 5.5h-2.3c-.1-1-.4-3.5-3.1-3.5s-2.9 1.4-2.9 3.1c0 1.7.9 3 3.6 4.3 3.7 1.8 5.1 3.6 5.1 6.8 0 3.2-1.9 5.9-5.9 5.9s-5.7-2.8-5.9-5.9h2.4l-.1-.1ZM77.9 1.1v21.4h-2.3V1.1h2.3ZM87.9 16.9c.2 2.2 1.2 4 3.6 4 2.4 0 3.4-1.2 3.4-3.7s-.9-3.5-3.8-4.9c-3.4-1.6-4.8-3.1-4.8-6.2S88.2.8 91.7.8c3.5 0 5.3 3 5.3 5.5h-2.3c-.1-1-.4-3.5-3.1-3.5s-2.9 1.4-2.9 3.1c0 1.7.9 3 3.6 4.3 3.7 1.8 5.1 3.6 5.1 6.8 0 3.2-1.9 5.9-5.9 5.9s-5.7-2.8-5.9-5.9H88l-.1-.1ZM107.9 3.2h-4.8V1.1H115v2.1h-4.8v19.3h-2.4V3.2h.1ZM131.5 12.3h-7.1v8.2h7.9l-.3 2.1h-9.9V1.2h9.8v2.1h-7.5v7h7.1v2.1-.1ZM152.5 13.4c0-4 0-8 .1-10.3-.8 3.7-2.7 12.6-4.4 19.4h-2.3c-1.3-5.9-3.3-15.5-4.1-19.4.1 2.5.2 7.2.2 10.9v8.5h-2.2V1.1h3.5c1.7 6.7 3.4 14.9 3.9 17.7.4-2.3 2.5-11.2 4.2-17.7h3.5v21.4h-2.3v-9.1h-.1ZM165.9 15.8l-1.6 6.8h-2.4l5.2-21.4h3l5.3 21.4h-2.5l-1.6-6.8h-5.6.2Zm5.1-2.1c-1.2-5.3-2-8.6-2.3-10.3-.3 1.9-1.2 5.7-2.2 10.3h4.6-.1Z"
            />
            </svg>
        </div>
        `, e.style.display = "block", e.style.position = "fixed", e.style.top = "0", e.style.left = "0", e.style.width = "100%", e.style.height = "100%", e.style.backgroundColor = "#3E4754", e.style.display = "flex", e.style.justifyContent = "center", e.style.alignItems = "center", e.style.color = "#fff", e.style.fontSize = "24px", e.style.zIndex = "999999", document.body.appendChild(e), e;
}
const Mn = () => {
  const t = window.location.href.split("?")[1], n = new URLSearchParams(t), r = Object.fromEntries(n.entries());
  r.continueAuth && (H(), setTimeout(function() {
    L("continue-digital", JSON.stringify({ continueAuth: r.continueAuth }));
  }, 2e3), setTimeout(function() {
    window.close();
  }, 3e3)), r.agetic ? (H(), setTimeout(function() {
    L("digital", r.agetic.replace("#/", ""));
  }, 2e3), setTimeout(function() {
    window.close();
  }, 3e3)) : r.approbation ? (H(), setTimeout(function() {
    L("documentDigital", r.approbation.replace("#/", ""));
  }, 2e3), setTimeout(function() {
    window.close();
  }, 3e3)) : r.logout ? (H(), setTimeout(function() {
    _("digital"), _("documentDigital"), _("dataAgetic"), _("ms_itm");
  }, 3e3), setTimeout(function() {
    window.close();
  }, 3500)) : r.redirectEmergency && (H(), setTimeout(function() {
    L("documentDigital", r.redirectEmergency.replace("#/", ""));
  }, 3e3), setTimeout(function() {
    window.close();
  }, 3500));
}, Un = async (e = { openWindows: !1, tokenMsSeguridad: null, verifyFunctionary: !0 }) => {
  try {
    _("digital-before"), _("continue-digital");
    const n = e.openWindows, r = M("digital");
    L("digital-before", r || "");
    const { url: o } = await Cn(r || "{}", e.tokenMsSeguridad, e.verifyFunctionary);
    let i;
    Ie() || n ? i = window.open(o, "_blank") : i = window.open(o, "Iniciar Sesion Ciudadania Digital", "width=700,height=700,resizable=no"), _("digital");
    var t = !1;
    const s = setInterval(function() {
      i != null && i.closed && (clearInterval(s), t = !0);
    }, 1e3);
    await (async () => {
      for (; !t; )
        await new Promise((d) => setTimeout(d, 100));
      return !0;
    })();
    let f = M("digital");
    if (JSON.parse(M("continue-digital") || "{}").continueAuth === "true")
      return setTimeout(function() {
        L("digital", M("digital-before") || "");
      }, 1e3), setTimeout(function() {
        _("digital-before");
      }, 2e3), { authContinue: !0, message: "Aun posee una session de agetic vigente" };
    if (f)
      if (f = JSON.parse(f), f && !f.error) {
        const h = await Nn(f.binnacleId);
        return _("digital-before"), document.dispatchEvent(new CustomEvent("timeLineSuccessLogin")), h;
      } else
        return f.error ? (document.dispatchEvent(new CustomEvent("timeLineErrorLogin")), f) : (document.dispatchEvent(new CustomEvent("timeLineErrorLogin")), null);
    else
      return document.dispatchEvent(new CustomEvent("timeLineErrorLogin")), null;
  } catch (n) {
    const r = n == null ? void 0 : n.response;
    if (r != null && r.closeSession && (r != null && r.binnacleId))
      return await Bn({ openWindows: !1, binnacleId: r.binnacleId });
  }
}, Bn = async (e = { openWindows: !1 }) => {
  const t = e.openWindows, n = e.binnacleId;
  let r = M("digital");
  if (r) {
    r = JSON.parse(r);
    const o = `${window.VITE_API_SERVER_REDIRECT ? window.VITE_API_SERVER_REDIRECT : "https://agetic.mp.gob.bo"}?urlRedirectLogout=${window.VITE_API_BASE_URL ? window.VITE_API_BASE_URL : "http://127.0.0.1:5173"}&binnacleId=${encodeURIComponent(n || r.binnacleId)}`;
    return Ie() || t ? window.open(o, "_blank") : window.open(o, "Cerrar Sesion Ciudadania Digital", "width=700,height=700,resizable=no"), _("digital"), _("documentDigital"), _("dataAgetic"), _("ms_itm"), { logout: !0 };
  }
}, Fn = async (e = { openWindows: !1, documentId: "", urlNotificationDocument: "none" }) => {
  const t = e.openWindows, n = e.documentId, r = e.urlNotificationDocument;
  _("documentDigital");
  let o = M("digital");
  if (o) {
    o = JSON.parse(o);
    let i = `${window.VITE_API_BASE_URL ? window.VITE_API_BASE_URL : "http://127.0.0.1:5173"}`, s;
    Ie() || t ? s = window.open(`${window.VITE_API_SERVER_REDIRECT ? window.VITE_API_SERVER_REDIRECT : "https://agetic.mp.gob.bo"}?urlRedirectClient=${encodeURIComponent(i)}&documentId=${encodeURIComponent(n)}&solicitudNavigationID=${Y("tabIdAgetic")}&binnacleId=${encodeURIComponent(o.binnacleId)}&urlNotificationDocument=${encodeURIComponent(r || "none")}`, "_blank") : s = window.open(
      `${window.VITE_API_SERVER_REDIRECT ? window.VITE_API_SERVER_REDIRECT : "https://agetic.mp.gob.bo"}?urlRedirectClient=${encodeURIComponent(i)}&documentId=${encodeURIComponent(n)}&solicitudNavigationID=${Y("tabIdAgetic")}&binnacleId=${encodeURIComponent(o.binnacleId)}&urlNotificationDocument=${encodeURIComponent(r || "none")}`,
      "Firma digital",
      "width=700,height=700,resizable=no"
    );
    let l = !1;
    const f = setInterval(function() {
      s != null && s.closed && (clearInterval(f), l = !0);
    }, 1e3);
    await (async () => {
      for (; !l; )
        await new Promise((y) => setTimeout(y, 100));
      return !0;
    })();
    const d = M("documentDigital"), h = d !== null ? JSON.parse(d) : null;
    if (h)
      return document.dispatchEvent(new CustomEvent("timeLineSuccessAprobation")), h;
    document.dispatchEvent(new CustomEvent("timeLineErrorAprobation"));
  }
}, kn = async (e, t) => {
  try {
    try {
      await xn();
    } catch (c) {
      throw alert(`EXITE PROBLEMAS CON SU FIRMATIC EN SU EQUIPO 
 Servicio:${window.VITE_API_LOCAL_FIRMATIC ? window.VITE_API_LOCAL_FIRMATIC : "https://localhost:4637"}`), c;
    }
    const n = await Pn(e), r = n == null ? void 0 : n.datos, o = r.voucher, i = {
      archivo: [
        {
          id: r.hash.id,
          base64: r.hash.filesDataToSign[0].value,
          date: r.hash.filesDataToSign[0].date
        }
      ],
      format: "pades_hash",
      language: "es"
    }, s = await Dn(i), l = {
      notificacionId: e.notificacionId,
      personaId: e.personaId,
      voucher: o,
      idHash: r.hash.id,
      certificado: s.certificate,
      cadenaConfianza: s.certificateChain,
      encriptacion: "RSA",
      firma: {
        algoritmo: s.files[0].algorithm,
        id: r.hash.filesDataToSign[0].id,
        valor: s.files[0].value
      },
      tokenMss: t,
      notification: n.notification
    };
    return await Ln(l);
  } catch (n) {
    throw n;
  }
}, Vn = {
  install(e, t) {
    Mn(), e.mixin({
      created() {
      }
    }), window.VITE_API_INTERMEDIARY_SEGURITY = t.VITE_API_INTERMEDIARY_SEGURITY, window.VITE_API_LOCAL_FIRMATIC = t.VITE_API_LOCAL_FIRMATIC, window.VITE_API_SERVER_REDIRECT = t.VITE_API_SERVER_REDIRECT, window.VITE_API_BASE_URL = t.VITE_API_BASE_URL, window.VITE_API_APLICATION = t.VITE_API_APLICATION, window.VITE_VERIFY_FUNCTIONARY = t.VITE_VERIFY_FUNCTIONARY === "true", window.VITE_TOKEN_SEGURITY_AGETIC = t.VITE_TOKEN_SEGURITY_AGETIC, window.VITE_DEVELOPMENT_ENVIRONMENT = t.VITE_DEVELOPMENT_ENVIRONMENT;
  }
};
export {
  Un as LoginDigital,
  Bn as LogoutDigital,
  Vn as default,
  Fn as validateDocument,
  kn as validateNotification
};
